import { render, staticRenderFns } from "./releaseActivities.vue?vue&type=template&id=f9bff69a&scoped=true&"
import script from "./releaseActivities.vue?vue&type=script&lang=js&"
export * from "./releaseActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bff69a",
  null
  
)

export default component.exports